import React, { useState } from "react";
import Card from "../Card";
import Spacing from "../Spacing";
import { numberWithCommas } from "../../helpers";

const FidelisCarejson = [
  {
    id: 1,
    name: "Antidepressant Medication Management-Acute Phase",
    count: 55
  },
  {
    id: 2,
    name: "Asthma Medication Ratio (AMR)",
    count: 19
  },
  {
    id: 3,
    name: "BPD-BP Control for Diabetes",
    count: 1140
  },
  {
    id: 4,
    name: "Breast Cancer Screening",
    count: 551
  },
  {
    id: 5,
    name: "Cervical Cancer Screening",
    count: 2334
  },
  {
    id: 6,
    name: "Child and Adolescent Well-Care Visits (WCV)",
    count: 959
  },
  {
    id: 7,
    name: "Childhood Immunization Status Combination 3",
    count: 18
  },
  {
    id: 8,
    name: "Chlamydia Screening in Women",
    count: 244
  },
  {
    id: 9,
    name: "COA - Functional Status Assessment",
    count: 52
  },
  {
    id: 10,
    name: "COA - Medication Review",
    count: 5
  },
  {
    id: 11,
    name: "COA - Pain Assessment",
    count: 53
  },
  {
    id: 12,
    name: "Colorectal Cancer Screening",
    count: 3022
  },
  {
    id: 13,
    name: "Controlling High Blood Pressure",
    count: 1488
  },
  {
    id: 14,
    name: "Diabetes Screening for People With Schizophrenia or Bipolar Disorder Who Are Using Antipsychotic Medications",
    count: 12
  },
  {
    id: 15,
    name: "EED-Eye Exam for Diabetes",
    count: 1046
  },
  {
    id: 16,
    name: "F/U after ED visit (MH) - 7 day rate",
    count: 41
  },
  {
    id: 17,
    name: "HBD-HbA1c Control for Diabetes",
    count: 2168
  },
  {
    id: 18,
    name: "Immunizations for Adolescents Combination 2",
    count: 30
  },
  {
    id: 19,
    name: "Kidney Health Evaluation for Patients With Diabetes (KED)",
    count: 826
  },
  {
    id: 20,
    name: "Lead Screening in Children",
    count: 7
  },
  {
    id: 21,
    name: "Oral Evaluation, Dental Services (OED)",
    count: 1835
  },
  {
    id: 22,
    name: "PPC-Postpartum Care",
    count: 190
  },
  {
    id: 23,
    name: "SPC-Statin Therapy for CVD",
    count: 43
  },
  {
    id: 24,
    name: "W30 Well Child 0-15 months",
    count: 28
  },
  {
    id: 25,
    name: "W30 Well Child 15-30 months",
    count: 4
  }
];

export default function FidelisCareMeasures() {
  const [fidelisCareMeasureData] = useState(FidelisCarejson);

  const calculateTotalRevenueMissed = () => {
    return fidelisCareMeasureData.reduce((total, item) => {
      return total + (item?.count || 0);
    }, 0);
  };

  return (
    <Card variant="docpro_card docpro_card_1 p-0">
      <div className="docpro_table_responsive">
        <table className="docpro_audit_table fidelis_care docpro_mb_0">
          <tbody>
            <tr>
              <td colSpan="2">
                <Spacing lg="15" sm="15" />
              </td>
            </tr>
            <tr>
              <td>
                <h2 className='docpro_fs_20 docpro_mb_0 pl-2'>Fidelis Care Measures</h2>
              </td>
              <td className='missed_td'>
                <h4 className='docpro_fs_16 docpro_fw_600 docpro_mb_0 text-right pr-2'>Pending Measures</h4>
              </td>
            </tr><tr>
              <td colSpan="2">
                <Spacing lg="2" sm="2" />
              </td>
            </tr>
            {fidelisCareMeasureData.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className="docpro_audit_progress pl-2">
                      <div className={`docpro_secondary_color docpro_audit_progress_in_1 progress`}>
                        <h5 className="docpro_fs_15 docpro_fw_500 docpro_mb_0">
                          {item?.name}
                        </h5>
                      </div>
                    </div>
                  </td>
                  <td>
                    <h5 className='docpro_fs_16 docpro_secondary_color docpro_fw_500 docpro_mb_0 text-right pr-2'>
                      {numberWithCommas(item?.count || 0)}
                    </h5>
                  </td>
                </tr>
              );
            })}

            <tr>
              <td colSpan="2">
                <Spacing lg="6" sm="6" />
              </td>
            </tr>
            <tr>
              <td style={{ borderTop: '1px solid var(--border)' }}>
                <h4 className='docpro_fs_16 docpro_fw_400 docpro_mb_0 docpro_secondary_color mt-2 mb-2 pl-2'>Grand Total</h4>
              </td>
              <td style={{ borderTop: '1px solid var(--border)' }}>
                <h4 className='docpro_fs_16 docpro_fw_700 docpro_mb_0 text-right docpro_primary_color mt-2 mb-2 pr-2'>{numberWithCommas(calculateTotalRevenueMissed())}</h4>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}
